import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import './GaugeBar.scss';

const GaugeBar = ({ percents, options = {} }) => {
  const barRef = useRef(null);
  const indicatorRef = useRef(null);
  const [left, setLeft] = useState(0);
  const [width, setWidth] = useState(0);
  const type = options.type || 'bar';
  const lowLabel = options.low_label || '';
  const highLabel = options.high_label || '';

  const calculateWidths = () => {
    if (!barRef.current || !indicatorRef.current) return { barWidth: 0, indicatorWidth: 0 };

    const barWidth = barRef.current.clientWidth;
    const indicatorWidth = indicatorRef.current.clientWidth;

    if (barWidth === 0) return { barWidth: 0, indicatorWidth: 0 };

    return { barWidth, indicatorWidth };
  };

  const placeIndicator = (barWidth, indicatorWidth) => {
    let leftPos = (barWidth / 100) * percents - indicatorWidth / 2;
    if (leftPos < 0) leftPos = 0;
    if (leftPos + indicatorWidth > barWidth) leftPos = barWidth - indicatorWidth;
    setLeft(leftPos);
  };

  const drawBar = (barWidth) => {
    let barFillWidth = (barWidth / 100) * percents;
    if (barFillWidth < 0) barFillWidth = 0;
    if (barFillWidth > barWidth) barFillWidth = barWidth;
    setWidth(barFillWidth);
  };

  const redraw = () => {
    if (percents === undefined) return;

    const { barWidth, indicatorWidth } = calculateWidths();
    if (barWidth === 0) return;

    if (type === 'bar') {
      drawBar(barWidth);
    } else {
      placeIndicator(barWidth, indicatorWidth);
    }
  };

  useEffect(() => {
    redraw();
  }, [percents]);

  useEffect(() => {
    // Initial draw
    const timer = setTimeout(() => {
      redraw();
    }, 0);

    // Handle resize if option is set
    const handleResize = () => {
      redraw();
    };

    if (options.resize) {
      window.addEventListener('resize', handleResize);
    }

    return () => {
      clearTimeout(timer);
      if (options.resize) {
        window.removeEventListener('resize', handleResize);
      }
    };
  }, [percents, options.resize, type]);

  const indicatorStyle = type === 'bar' ? { width: `${width}px` } : { left: `${left}px` };

  return (
    <div className="am-gauge-chart">
      <table className="spread-all">
        <tbody>
          <tr>
            {lowLabel && <td className="label left-label">{lowLabel}</td>}
            <td className="bar-cell">
              <div className="bar" ref={barRef}></div>
              <div className={`indicator-bar ${type}-type`} style={indicatorStyle} ref={indicatorRef}></div>
            </td>
            {highLabel && <td className="label right-label">{highLabel}</td>}
          </tr>
        </tbody>
      </table>
    </div>
  );
};

GaugeBar.propTypes = {
  percents: PropTypes.number,
  options: PropTypes.shape({
    type: PropTypes.oneOf(['bar', 'indicator']),
    low_label: PropTypes.string,
    high_label: PropTypes.string,
    resize: PropTypes.bool,
  }),
};

export default GaugeBar;
